'use strict';
import * as $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6 from "./internal-3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.js";
import * as $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c from "./internal-9eb04c7a932b923c3bc5eb25fd6219ee930b689c.js";
var $p;
/** @constructor */
function $c_Lapp_data_ids$package$DocumentTemplateId$() {
  this.aU9 = null;
  this.aUa = false;
  this.aU5 = null;
  this.aU6 = false;
  this.aUb = null;
  this.aUc = false;
  this.aUd = null;
  this.aUe = false;
  this.aU7 = null;
  this.aU8 = false;
}
export { $c_Lapp_data_ids$package$DocumentTemplateId$ as $c_Lapp_data_ids$package$DocumentTemplateId$ };
$p = $c_Lapp_data_ids$package$DocumentTemplateId$.prototype = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$h_Lneotype_Newtype();
$p.constructor = $c_Lapp_data_ids$package$DocumentTemplateId$;
/** @constructor */
function $h_Lapp_data_ids$package$DocumentTemplateId$() {
}
export { $h_Lapp_data_ids$package$DocumentTemplateId$ as $h_Lapp_data_ids$package$DocumentTemplateId$ };
$h_Lapp_data_ids$package$DocumentTemplateId$.prototype = $p;
$p.aA = (function() {
  if ((!this.aUa)) {
    this.aU9 = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_NewtypeULID$$anon$1(this);
    this.aUa = true;
  }
  return this.aU9;
});
$p.aC = (function() {
  if ((!this.aU6)) {
    this.aU5 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeULID__circeCodec__Lio_circe_Codec(this);
    this.aU6 = true;
  }
  return this.aU5;
});
$p.fI = (function() {
  if ((!this.aUc)) {
    this.aUb = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$f_Lframework_utils_NewtypeULID__tapirCodec__Lsttp_tapir_Codec(this);
    this.aUc = true;
  }
  return this.aUb;
});
$p.Ke = (function() {
  if ((!this.aUe)) {
    this.aUd = new $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$c_Lframework_utils_UrlConvertible$fromCodec(this.fI(), $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lurldsl_errors_DummyError$().sR());
    this.aUe = true;
  }
  return this.aUd;
});
$p.bsb = (function() {
  if ((!this.aU8)) {
    this.aU7 = $j_internal$002d3ebfae0cba70adf981029a0da5b1e4b5ab5d02c6.$m_Lframework_data_Base64Id$().auo().bw("Document template ID");
    this.aU8 = true;
  }
  return this.aU7;
});
var $d_Lapp_data_ids$package$DocumentTemplateId$ = new $j_internal$002d9eb04c7a932b923c3bc5eb25fd6219ee930b689c.$TypeData().i($c_Lapp_data_ids$package$DocumentTemplateId$, "app.data.ids$package$DocumentTemplateId$", ({
  GL: 1,
  B: 1,
  C: 1,
  h8: 1
}));
export { $d_Lapp_data_ids$package$DocumentTemplateId$ as $d_Lapp_data_ids$package$DocumentTemplateId$ };
var $n_Lapp_data_ids$package$DocumentTemplateId$;
function $m_Lapp_data_ids$package$DocumentTemplateId$() {
  if ((!$n_Lapp_data_ids$package$DocumentTemplateId$)) {
    $n_Lapp_data_ids$package$DocumentTemplateId$ = new $c_Lapp_data_ids$package$DocumentTemplateId$();
  }
  return $n_Lapp_data_ids$package$DocumentTemplateId$;
}
export { $m_Lapp_data_ids$package$DocumentTemplateId$ as $m_Lapp_data_ids$package$DocumentTemplateId$ };
//# sourceMappingURL=app.data.ids$package$-Document-Template-Id$.js.map
